import React from 'react'

const PrivacyPolicy = () => (
  <>
    <p>
      Glue Collaboration (<strong>“Glue”</strong> or <strong>“we”</strong>) provides “Glue”, a virtual environment for hosting meetings and thereto related websites (<strong>“Service”</strong>) where Users can create and manage the collaborative virtual reality space and host and access the virtual meeting spaces. This Privacy Policy applies to the Service and the processing of personal data in connection with the provision of the Service.
    </p>
    <br />
    <p>
      In this Privacy Policy we explain how we process the data of the representatives and users of our business partners, customers and potential customers using the Service (<strong>“User”</strong> or <strong>“you”</strong>).
    </p>
    <br />
    <p>
      This Privacy Policy may be updated from time to time in order to reflect the changes in data processing practices or otherwise.
    </p>
    <br />
    <p>
      This Privacy Policy applies to processing of personal data carried out by Glue as data controller. For clarity, we emphasise that this Privacy Policy does not address and is not applicable to the processing of personal data collected by third parties.
    </p>
    <br />
    <h1>
      Glue&apos;s contact details
    </h1>
    <br />
    <p>
      Name: Glue Collaboration<br />
      Company ID: 2273132-2<br />
      Correspondence address:<br />
      Meritullinkatu 11 C 00170 Helsinki Finland<br />
      E-mail address: support@glue.work<br />
      www.glue.work<br />
    </p>
    <br />
    <h1>
      1. Personal data processed and sources of data
    </h1>
    <br />
    <p>
      The personal data collected and processed by us in connection with your registration to and use of the Service can be divided into two general data categories: User Data and Analytics Data.
    </p>
    <br />
    <h2>
      User Data
    </h2>
    <br />
    <p>
      User Data is personal data collected directly from you or generated by our Service or us based on your use of the Service. We may collect User Data from our Users in a variety of ways, including, when they register to and use the Service, subscribe to a newsletter or fill out a form.
    </p>
    <br />
    <p>
      The following personal data collected and processed by us is necessary for our legitimate interest whilst fulfilling our contractual obligations towards our customer and other organizations and you and for the compliance with our legal obligations.
    </p>
    <br />
    <p>
      When User registers to the Service, we may collect the following information:
    </p>
    <br />
    <li>first and last name</li>
    <li>email address</li>
    <li>phone number</li>
    <li>position in the company</li>
    <li>username</li>
    <li>password</li>
    <br />
    <h2>
      User Data you give us voluntarily
    </h2>
    <br />
    <p>
      We may also process other information provided by you voluntarily such as:
    </p>
    <br />
    <li>marketing opt-ins and opt-outs</li>
    <li>data on your use of and interaction with the Service</li>
    <li>data you have entered to the Service</li>
    <li>information you provide in correspondence with us</li>
    <br />
    <h2>
      Analytics Data
    </h2>
    <br />
    <p>
      The logging systems used by our Service automatically log certain Analytics Data when you visit our Service. Although we do not normally use Analytics Data to identify you as an individual, you can sometimes be recognised from it, either alone or when combined or linked with User Data. In such situations, Analytics Data can also be considered personal data under applicable laws and we will treat such data as personal data.
    </p>
    <br />
    <p>
      We may automatically collect the following Analytics Data when you visit or interact with our Service:
    </p>
    <br />
    <p>
      <strong>Device Information.</strong> We collect the following information relating to the technical device you use when using the Service:
    </p>
    <br />
    <li>device and device identification number, device IMEI</li>
    <li>country</li>
    <li>IP address</li>
    <li>browser type and version</li>
    <li>operating system</li>
    <li>name of your Internet service providers</li>
    <li>advertising identifier of your device</li>
    <br />
    <p>
      <strong>Usage Information.</strong> We collect information on your use of the Service, such as:
    </p>
    <br />
    <li>time spent on the Service</li>
    <li>interaction with the Service</li>
    <li>the time and date of your visits to the Service</li>
    <li>the searches you made on the Service</li>
    <br />
    <h2>
      Cookies
    </h2>
    <br />
    <p>
      We use various technologies to collect and store Analytics Data and other information when the Users visit our website, including cookies, pixel tags and web beacons.
    </p>
    <br />
    <p>
      Cookies are small text files sent and saved on your device that allows us to identify visitors of our website and facilitate the use of the website and the Service and to create aggregate information of our visitors. This helps us to improve the Service and better serve our Users. The cookies will not harm your device or files. We use cookies to tailor our website and the Service and the information we provide in accordance with the individual interests of our Users.
    </p>
    <br />
    <p>
      The Users may choose to set their web browser to refuse cookies, or to alert when cookies are being sent. For example, the following sites provide information on how to adjust the cookie settings on some popular browsers:
    </p>
    <br />
    <p>
      Safari: https://support.apple.com/kb/PH19214
    </p>
    <p>
      Google Chrome: https://support.google.com/chrome/answer/95647
    </p>
    <p>
      Internet Explorer: https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies#ie=ie-11
    </p>
    <p>
      Mozilla Firefox: https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer
    </p>
    <br />
    <p>
      Please note that some parts of our Service may not function properly if use of cookies is refused.
    </p>
    <br />
    <p>
      A web beacon is a technology that allows identifying readers of websites and emails e.g. for identifying whether an email has been read.
    </p>
    <br />
    <h2>
      Web analytics Service
    </h2>
    <br />
    <p>
      Our website uses Google Analytics and other web analytics Service to compile Analytics Data and reports on visitor usage and to help us improve our website and the Service. For an overview of Google Analytics, please visit Google Analytics (http://www.google.com/analytics). It is possible to opt-out of Google Analytics with the following browser add-on tool: Google Analytics opt-out add-on (https://support.google.com/analytics/answer/181881).
    </p>
    <br />
    <h1>
      2. Purposes and legitimate grounds for the processing of your personal data
    </h1>
    <br />
    <h2>
      Purposes
    </h2>
    <br />
    <p>
      There are several purposes of the processing of your personal data by Glue:
    </p>
    <br />
    <h2>
      To provide you the Service
    </h2>
    <br />
    <p>
      Glue processes your personal data to be able to make the Service available to you and to the entity you are representing.
    </p>
    <br />
    <p>
      If you contact our customer service, we will use the information provided by you to answer your questions or solve your complaint.
    </p>
    <br />
    <h2>
      For our legal obligations
    </h2>
    <br />
    <p>
      Glue processes data to enable us to administer and fulfil our obligations under the law. This includes data processed for complying with our bookkeeping obligations and providing information to relevant authorities such as tax authorities.
    </p>
    <br />
    <h2>
      For claims handling and legal processes
    </h2>
    <br />
    <p>
      Glue may process personal data in relation to claims handling, debt collection and legal processes pertaining to the data subject or the company the data subject represents. We may also process data for the prevention of fraud, misuse of our Service and for data, system and network security.
    </p>
    <br />
    <h2>
      For general communication and marketing
    </h2>
    <br />
    <p>
      Glue processes your personal data to contact you regarding the Service and to inform you of changes relating to it. Your personal data is also used for the purposes of marketing the Service to the company you are representing.
    </p>
    <br />
    <h2>
      For quality improvement and trend analysis
    </h2>
    <br />
    <p>
      We may also process information about your use of our website and the Service to improve their quality e.g. by analysing any trends in their use. In order to ensure that our website and the Service are in line with your needs, personal data can be used for things like customer satisfaction surveys. When possible, we will do this using only aggregated, non-personally identifiable data.
    </p>
    <br />
    <h2>
      Legal grounds for processing
    </h2>
    <br />
    <p>
      Glue processes your personal data primarily to pursue our legitimate interest to run, maintain and develop our business and to create and maintain customer and other business relationships. When choosing to use your data on the basis of our legitimate interests, we weigh our own interests against your right to privacy and e.g. provide you with easy to use opt-out from our marketing communications and use pseudonymised or non-personally identifiable data when possible.
    </p>
    <br />
    <p>
      We may also process your personal data in order to comply with legal obligations.
    </p>
    <br />
    <p>
      In some parts of the Service, you may be requested to grant your consent for the processing of personal data. In this event, you may withdraw your consent at any time.
    </p>
    <br />
    <h1>
      3. Transfers to countries outside Europe
    </h1>
    <br />
    <p>
      We process personal data primarily within the European Economic Area. However, we have service providers in several geographical locations. As such, we and our service providers may transfer your personal data to, or access it in, jurisdictions outside the European Economic Area.
    </p>
    <br />
    <p>
      We will take steps to ensure that the Users&apos; personal data receives an adequate level of protection in the jurisdictions in which they are processed. We provide adequate protection for the transfers of personal data to countries outside of the European Economic Area through a series of agreements with our service providers based on the Standard Contractual Clauses (https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transfer-personal-data-third-countries_en) or through other appropriate safeguards, such as the Privacy Shield Framework (https://www.privacyshield.gov).
    </p>
    <br />
    <p>
      More information regarding the transfers of personal data may be obtained by contacting us on any of the addresses indicated above.
    </p>
    <br />
    <h1>
      4. Recipients
    </h1>
    <br />
    <p>
      We only share your personal data within our organisation if and as far as reasonably necessary for the purposes of this Privacy Policy.
    </p>
    <br />
    <p>
      We do not share your personal data with third parties outside of Glue&apos;s organisation unless one of the following circumstances applies:
    </p>
    <br />
    <h2>
      For the purposes set out in this Privacy Policy and to authorised service providers
    </h2>
    <br />
    <p>
      To the extent that third parties need access to User Data in order for us to provide the Service, we provide such third parties with your data (such as our authentication service partners). Furthermore, we may provide your personal data to our affiliates or to authorised service providers who perform services for us (including accounting, payment, hosting and advertising partners).
    </p>
    <br />
    <p>
      When your personal data is processed by third parties as data processors on behalf of Glue, Glue has taken the appropriate contractual and organisational measures to ensure that your data is processed exclusively for the purposes specified in this Privacy Policy and in accordance with all applicable laws and regulations and subject to our instructions and appropriate obligations of confidentiality and security measures.
    </p>
    <br />
    <h2>
      For legal reasons and legal processes
    </h2>
    <br />
    <p>
      We may share your personal data with third parties outside our organisation if we have a good-faith belief that access to and use of the personal data is reasonably necessary to: (i) meet any applicable law, regulation, and/or court order; (ii) detect, prevent, or otherwise address fraud, crime, security or technical issues; and/or (iii) protect the interests, properties or safety of Glue, the Users or the public as far as in accordance with the law. When possible, we will inform you about such processing.
    </p>
    <br />
    <h2>
      For other legitimate reasons
    </h2>
    <br />
    <p>
      If Glue is involved in a merger, acquisition or asset sale, we may transfer your personal data to the third party involved. However, we will continue to ensure the confidentiality of all personal data. We will give notice to all the Users concerned when the personal data is transferred or become subject to a different privacy policy.
    </p>
    <br />
    <h2>
      With your explicit consent
    </h2>
    <br />
    <p>
      We may share your personal data with third parties outside Glue when we have your explicit consent to do so. You have the right to withdraw this consent at all times.
    </p>
    <br />
    <h1>
      5. Storage period
    </h1>
    <br />
    <p>
      Glue does not store your personal data longer than is legally permitted and necessary for the purposes of this Privacy Policy. The storage period depends on the nature of the information and on the purposes of processing. The maximum period may therefore vary per use.
    </p>
    <br />
    <p>
      Most personal data relating to a registered User will be deleted after a period of 12 months has lapsed after the User in question has terminated their registration with the Service. Thereafter, some of the personal data may be stored by us only as long as such processing is required by law or is reasonably necessary for our legal obligations or legitimate interests such as claims handling, bookkeeping, internal reporting and reconciliation purposes.
    </p>
    <br />
    <p>
      We will store Analytics Data of Users that do not have an account with the Service for a period of 12 months.
    </p>
    <br />
    <h1>
      6. Your rights
    </h1>
    <br />
    <h2>
      Right to access
    </h2>
    <br />
    <p>
      You have the right to access and be informed about your personal data processed by us. We give you the possibility to view certain User Data through your user account on the Service or request a copy of your personal data.
    </p>
    <br />
    <h2>
      Right to withdraw consent
    </h2>
    <br />
    <p>
      In case the processing is based on a consent granted by the User, the User may withdraw the consent at any time. Withdrawing a consent may lead to fewer possibilities to use our website and the Service. The withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal.
    </p>
    <br />
    <h2>
      Right to rectify
    </h2>
    <br />
    <p>
      You have the right to have incorrect or incomplete personal data we have stored about you corrected or completed by contacting us. You can correct or update some of your User Data through your user account on the Service.
    </p>
    <br />
    <h2>
      Right to erasure
    </h2>
    <br />
    <p>
      You may also ask us to delete your personal data from our systems. We will comply with such request unless we have a legitimate ground to not delete the data.
    </p>
    <br />
    <h2>
      Right to object
    </h2>
    <br />
    <p>
      You may have the right to object to certain use of your personal data if such data are processed for other purposes than necessary for the provision of our website or the Service or for compliance with a legal obligation. If you object to the further processing of your personal data, this may lead to fewer possibilities to use our website and the Service.
    </p>
    <br />
    <h2>
      Right to restriction of processing
    </h2>
    <br />
    <p>
      You may request us to restrict processing of personal data for example when your data erasure, rectification or objection requests are pending and/or when we do not have legitimate grounds to process your data. This may however lead to fewer possibilities to use our website and the Service.
    </p>
    <br />
    <h2>
      Right to data portability
    </h2>
    <br />
    <p>
      You have the right to receive the personal data you have provided to us yourself in a structured and commonly used format and to independently transmit those data to a third party.
    </p>
    <br />
    <h2>
      How to use your rights
    </h2>
    <br />
    <p>
      The abovementioned rights may be used by sending a letter or an e-mail to us on the addresses set out above, including the following information: full name, address, e-mail address and a phone number. We may request the provision of additional information necessary to confirm the identity of the User. We may reject requests that are unreasonably repetitive, excessive or manifestly unfounded.
    </p>
    <br />
    <h1>
      7. Direct marketing
    </h1>
    <br />
    <p>
      The User has the right to prohibit us from using the User&apos;s personal data for direct marketing purposes, market research and profiling made for direct marketing purposes by contacting us on the addresses indicated above or by using the unsubscribe possibility offered in connection with any direct marketing messages.
    </p>
    <br />
    <h1>
      8. Lodging a complaint
    </h1>
    <br />
    <p>
      In case the User considers our processing of personal data to be inconsistent with the applicable data protection laws, a complaint may be lodged with the local supervisory authority for data protection. In Finland, the local supervisory authority is the Data Protection Ombudsman (www.tietosuoja.fi).
    </p>
    <br />
    <h1>
      9. Information security
    </h1>
    <br />
    <p>
      We use administrative, organisational, technical, and physical safeguards to protect the personal data we collect and process. Measures include for example, where appropriate, encryption, pseudonymisation, firewalls, secure facilities and access right systems. Our security controls are designed to maintain an appropriate level of data confidentiality, integrity, availability, resilience and ability to restore the data. We regularly test our website and the Service, systems, and other assets for security vulnerabilities.
    </p>
    <br />
    <p>
      Should despite of the security measures, a security breach occur that is likely to have negative effects to the privacy of the Users, we will inform the relevant Users and other affected parties, as well as relevant authorities when required by applicable data protection laws, about the breach as soon as possible.
    </p>
  </>
)

export default PrivacyPolicy
